import { Directive, EventEmitter, Output, ElementRef, NgZone, Input } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

declare let google: any;

@Directive({
    selector: '[ebbGoogleAutocomplete]',
    standalone: false
})
export class GoogleAutoCompleteDirective  {
    @Output() whenSelected: EventEmitter<any> = new EventEmitter<any>();
    @Input() public value: any;

    private element: HTMLInputElement;
    private autoCompleteService: any;
    private session: any;
    private token: any;

    constructor(
        private elRef: ElementRef,
        public zone: NgZone
    ) {
        this.element = this.elRef.nativeElement;

        fromEvent(this.element, 'focus').subscribe(val => {
            window['angularGoogleAutocompleteDirectiveRef'] = { component: this, zone: this.zone };
        });

        fromEvent(this.element, 'input').pipe(debounceTime(600)).subscribe(val => {
            if (this.element.value.length >= 5 && this.element === document.activeElement) {
                this.getPrediction(this.element.value);
            }
            if (this.element.value.length < 4) {
                this.getPrediction('');
            }
        });

        fromEvent(this.element, 'focusout').pipe(debounceTime(300)).subscribe(val => {
            this.whenSelected.emit([]);
        })
    }

    public async getPrediction(value: string) {
        if (!this.isServiceAvailable()) {
            return;
        }
        if (value) {

            const bounds = new google.maps.LatLngBounds(new google.maps.LatLng(32.342841356393016, -124.727783203125), new google.maps.LatLng(42.01665183556825, -114.05868530273438));

            const autocompleteRequest = {
                input: value,
                locationRestriction: bounds,
                sessionToken: this.session,
            };

            const { suggestions } = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(autocompleteRequest);

            window['angularGoogleAutocompleteDirectiveRef'].zone.run(() => {
                window['angularGoogleAutocompleteDirectiveRef']
                    .component.whenSelected.emit(suggestions);
            });
        } else {
            this.whenSelected.emit([]);
        }
    }

    //way to handle google maps library loading async
    //quick way for now to avoid typescript implementation and reference errors
    //https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
    public isServiceAvailable() {
        if (this.autoCompleteService) {
            return true;
        }

        if (google.maps.places) {
            this.session = new google.maps.places.AutocompleteSessionToken();

            return true;
        }

        return false;
    }
}
